module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-HOUZZ.86b870be.png";